<div class="htst-info-container">
  <div class="header-info">
    <div>
      <i
        nz-icon
        [nzType]="'icons:steamtrap-small-icon'"
        class="svg-icon big-icon"
      ></i>
    </div>
    <div class="body-bold">{{ sensorType() }}</div>
  </div>

  @if (formattedInfo().length > 0) {
    @for (item of formattedInfo(); let i = $index; track i) {
      <div class="htst-info-box">
        <div class="body-bold-cap">{{ item.label }}</div>
        @if (item.label === i18n.langString("sensor_color")) {
          <div
            class="info-slate color-box"
            [style.background-color]="item.value"
          ></div>
        } @else {
          <div class="info-slate">{{ item.value }}</div>
        }
      </div>
    }
  } @else {
    <div class="htst-info-box">
      <div class="info-slate">{{ i18n.langString("no_data_available") }}</div>
    </div>
  }
</div>
